import { useMemo } from 'react';
import { useMutation } from '@apollo/client'; 
import { v4 as uuidv4 } from 'uuid';
import { message } from 'antd';
import CREATE_ASSET from '../../gql/mutations/CREATE_ASSET';
import { CREATE_IMAGE_MUTATION } from '../queries/CREATE_IMAGE';
  
const useCreateImageThumbnail = () => {
    const [ createImage ] = useMutation( CREATE_IMAGE_MUTATION );
    
    const createImageThumbnail = async ( file ) => {
        
        try {  
            const variables = {
                'input': {
                    'file': file
                }
            }; 
         
            const response = await createImage( { variables } );    
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            const newAsset = response?.data?.createImage?.url;

            if ( success && newAsset ) {
                return newAsset;
            } else {
                message.error( 'Error uploading image!' );
                return false;
            }
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error uploading image!' );
            return false;
        }
    };

    return useMemo( () => {
        return {
            createImageThumbnail
        };
    }, [ ] );
};

export default useCreateImageThumbnail;
